export async function triggerBrowserDownload(url: string, filename: string): Promise<void> {
    const absoluteUrl = new URL(url, window.location.href).href;

    try {
        const response = await fetch(absoluteUrl);
        if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
        }

        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = filename;
        link.rel = "noopener";
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(blobUrl);
        return;
    } catch {
        const link = document.createElement("a");
        link.href = absoluteUrl;
        link.download = filename;
        link.rel = "noopener";
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        link.remove();
    }
}
